/**
 * Etiquetas i18n de gamificación (badges/logros).
 *
 * El core `gamification-core` es AGNÓSTICO de i18n: un badge se identifica por
 * su `id` estable (p. ej. `"first-lesson"`) y NO renderiza texto. Aquí la app
 * web mapea cada id a un `MessageDescriptor` traducible (patrón `BLOCK_KINDS`).
 * Los consumidores renderizan con `t(BADGE_LABELS[id])`.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

/** id de badge (de `spaceGamificationConfig.badges`) → etiqueta localizada. */
const BADGE_LABELS: Record<string, MessageDescriptor> = {
  "first-lesson": msg`First lesson`,
  "ten-lessons": msg`10 lessons`,
  "hundred-lessons": msg`100 lessons`,
  "streak-7": msg`7-day streak`,
  "streak-30": msg`30-day streak`,
  "first-course": msg`First course completed`,
  scholar: msg`Scholar (level 5)`,
  sage: msg`Sage (level 10)`,
};

/** Etiqueta de un badge por id, con fallback al propio id si no está mapeado. */
export function badgeLabel(id: string): MessageDescriptor | string {
  return BADGE_LABELS[id] ?? id;
}
